import React from 'react'
import { useGetDiscountCouponCode, useGetOnlineCourseDetail, useNewCourseDetail } from '../../assets/api/useGetApi';
import { useToaster } from './ToasterProvider';
import { useParams } from 'react-router-dom';
import { Box, IconButton, InputBase, Typography } from '@mui/material';
import useCouponStore from '../store/useCouponStore';
import { CustomButtonContained } from './CustomButton';
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import useAuthStore from '../store/useAuthStore';

const CouponBoxUi = ({ totalPrice }) => {
    const { showToaster } = useToaster();
    const token = useAuthStore((state) => state.accessToken);
    const { slug, apartments_id } = useParams();
    const { data: newCourse } = useNewCourseDetail({ slug });
    const { data: CourseDetail, isLoading } = useGetOnlineCourseDetail({ slug: slug })
    const course_id = newCourse?.data?.id || CourseDetail?.data?.id
    const { data: couponCodeList } = useGetDiscountCouponCode({ course_id: course_id, apartment_id: apartments_id });
    const { setCouponData, resetCouponData } = useCouponStore();
    const today = new Date().toISOString().split("T")[0];
    const couponArray = couponCodeList?.data
        ?.filter(item => today >= item?.start_date && today <= item?.end_date)
        ?.map(item => ({
            coupon: item?.coupon_code,
            price: item?.discount_amount,
        }));
    const [isPassed, setIsPassed] = React.useState(false);
    const [couponFound, setCouponFound] = React.useState({});
    const [coupon, setCoupon] = React.useState("");
    const [couponInvalid, setCouponInvalid] = React.useState(false);
    const [showCouponInput, setShowCouponInput] = React.useState(false);
    const computedPrice =
        isPassed && totalPrice >= couponFound?.price
            ? totalPrice - couponFound?.price
            : totalPrice;

            

    React.useEffect(() => {
        setCouponData({
            isPassed: isPassed,
            finalPrice: Number(computedPrice),
        })
    }, [computedPrice, isPassed]);

    React.useEffect(() => {
        if (isPassed && totalPrice < couponFound?.price) {
            setIsPassed(false);
            setCouponInvalid(true);
        } else {
            setCouponInvalid(false);
        }
    }, [totalPrice]);

    const handleCheckCouponCode = () => {
        const foundCoupon = couponArray.find(c => c.coupon === coupon);

        if (foundCoupon) {
            if (totalPrice >= foundCoupon?.price) {
                showToaster('Success', 'Congratulations! You got a discount with this coupon code.', 'success');
                setCouponFound(foundCoupon);
                setIsPassed(true);
                // const price  = totalPrice >= couponFound?.price
                //     ? totalPrice - couponFound?.price
                //     : totalPrice;
                // setTotalPriceWithCoupon(price);
            } else {
                showToaster('Warning!', `Coupon is only valid for purchases above ₹${foundCoupon.price}.`, 'error');
                setIsPassed(false);
            }
        } else {
            showToaster('Warning!', 'Invalid coupon code.', 'error');
            setIsPassed(false);
        }

        setCoupon("");
    };

    // ✅ Optional: clear on unmount
    React.useEffect(() => {
        return () => resetCouponData();
    }, []);
    return (





        <>
            {/* { 
                             newCourse?.data?.title !== "MISSION DOMINO FALL" &&
                             <Typography variant='body1' fontSize={"12px"} textAlign={"center"} color='red.main'> 
                            {newCoursesDetail?.data?.[0]?.batch_start_date} - {newCoursesDetail?.data?.[0]?.batch_end_date} 
                          </Typography> 
                          } */}

            {isPassed ? (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: "rgba(76, 175, 80, 0.1)",
                        borderRadius: "8px",
                        padding: "0.5rem 1rem",
                        width: "100%",
                        mt: 1,
                    }}
                >
                    <Typography variant="body2" color="green" fontWeight={500}>
                        🎉 Yehh! Coupon code {couponFound?.coupon} applied
                    </Typography>

                    <CustomButtonContained
                        buttonText="Cancel"
                        onClick={() => {
                            setIsPassed(false);
                            setCoupon("");
                            setShowCouponInput(false);
                            setCouponInvalid(false);
                        }}
                    />
                </Box>
            ) : couponInvalid ? (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: "rgba(244, 67, 54, 0.1)",
                        borderRadius: "8px",
                        padding: "0.5rem 1rem",
                        width: "100%",
                        mt: 1,
                    }}
                >
                    <Typography variant="body2" color="error" fontWeight={500}>
                        ⚠️ Coupon code {couponFound?.coupon} is no longer valid. Minimum amount ₹{couponFound?.price} required.
                    </Typography>
                    <CustomButtonContained
                        buttonText="Retry"
                        onClick={() => {
                            setShowCouponInput(true);
                            setCouponInvalid(false);
                        }}
                    />
                </Box>
            ) : !showCouponInput ? (
                <>
                    {token && <Typography
                        variant="body2"
                        color="red.main"
                        sx={{
                            mt: 1,
                            cursor: "pointer",
                            textDecoration: "underline",
                            textAlign: "center",
                        }}
                        onClick={() => setShowCouponInput(true)}
                    >
                        Do you have a coupon code?
                    </Typography>}
                </>
            ) : (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "rgba(139, 48, 48, 0.1)",
                        borderRadius: "8px",
                        padding: "0 0.5rem",
                        width: "100%",
                        height: "2.5rem",
                        mt: 1,
                    }}
                >
                    <InputBase
                        placeholder="Enter Coupon Code"
                        sx={{
                            flex: 1,
                            pl: 1,
                            textTransform: "uppercase",
                            "&::placeholder": {
                                color: "#fff",
                                opacity: 0.8,
                            },
                        }}
                        value={coupon.toUpperCase()}
                        onChange={(e) => setCoupon(e.target.value.toUpperCase())}
                    />

                    <IconButton
                        sx={{
                            backgroundColor: "red.main",
                            color: "#fff",
                            borderRadius: "8px",
                            ml: 1,
                            py: 0.3,
                            px: 1.5,
                            "&:hover": {
                                backgroundColor: "red.main",
                            },
                        }}
                        onClick={handleCheckCouponCode}
                    >
                        <ArrowForwardIcon />
                    </IconButton>
                </Box>
            )}

        </>



    )
}

export default CouponBoxUi
